import request from './request';

/**
 * 编辑车辆数据
 */
export function editVehicle(params) {
    return request('/vehicle', {
        method: 'PUT',
        params,
    });
}

/**
 * 修改车辆行驶里程
 */
export function editVehicleMileage(vehicleId, params) {
    return request(`/vehicle/${vehicleId}/mileage`, {
        method: 'PUT',
        params,
    });
}

/**
 * 修改车辆下次保养信息
 */
export function editVehicleMaintain(vin, params) {
    return request(`/maintenance/clue/next-maintenance/${vin}`, {
        method: 'PUT',
        params,
    });
}

// 修改保养提醒状态
export function editVehicleAlarm(params) {
    return request('/vehicle/alarm', {
        method: 'PUT',
        params,
        headers: {
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}
// 人车解绑
export function unbindVehicleAssociated(params) {
    return request('/vehicle/unbind', {
        method: 'DELETE',
        params,
    });
}

// 车辆操作记录
export function getHistory(cusVehicleOrgId, params) {
    return request(`/vehicle/${cusVehicleOrgId}/oplog`, {
        method: 'GET',
        params,
    });
}

// 查询车辆详情里面的权益
export function getService(vehicleId) {
    return request(`/vehicle/${vehicleId}/services`, {
        method: 'GET',
    });
}

// tab合并
// 车辆列表
export function getVehicleList(params) {
    return request('/vehicle/list', {
        method: 'POST',
        params,
    });
}
// 车辆详
export function getVehicleDetail(id, params) {
    return request(`/vehicle/${id}`, {
        method: 'GET',
        params,
    });
}
// 车架号上传
export function uploadVin(params) {
    return request('/vehicle/upload/vin', {
        method: 'POST',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}
/**
 *  根据车架号查询车型
 */
export function getVehicleByVin(params) {
    return request('/vehicle/vehicle-customer', {
        method: 'GET',
        params,
    });
}
/**
 *  根据车架号查询是否存在购车日期
 */
export function getHasPurchaseDateByVin(params) {
    return request('/vehicle/exist-purchase-date', {
        method: 'GET',
        params,
    });
}
/**
 *  查询车辆问题
 */
export function getVehicleProblems(params) {
    return request('/vehicle/problems', {
        method: 'GET',
        params,
    });
}
/**
 *  车辆问题--标记修复
 */
export function vehicleProblemRepair(params) {
    return request('/vehicle/problems/item/manual-repair', {
        method: 'PATCH',
        params,
    });
}
